import { clone } from 'lodash';

const replaceArray = (array, index, newValue) => {
  const newArray = clone(array);
  newArray[index] = newValue;
  return newArray;
};

export default replaceArray;
